import { grey } from "@mui/material/colors";

const styles = {
  paper: {
    backgroundColor: "white",
    border: `1px solid black`,
    borderRadius: 2,
    p: 3,
    maxWidth: { xs: "auto", lg: 350 },
    display: "flex",
  },
  text: {
    color: grey[700],
  },
  closeButton: {
    fontSize: 14,
    width: 25,
    height: 25,
    position: "absolute",
    top: 10,
    right: 10,
  },
  discount: {
    mt: 1,
    color: "green.main",
    fontSize: 12,
  },
};

export default styles;
